<div class="container mt-4 mb-5">
  <div class="row">
    <div
      *ngIf="pedido && !pedido.itens.length"
      class="col-lg-6 offset-lg-3 text-center"
    >
      <h5>Pedido vazio!</h5>
      <img src="assets/empty-cart.png" class="img-fluid" />
    </div>
    <div *ngIf="pedido && pedido.itens.length" class="col-lg-12">
      <div class="row">
        <!--  <div class="col-lg-3 col-sm-6">
          <img
            id="gcc-logo-agilb2b"
            src="{{ API_IMAGENS }}logo.png"
            style="height: 60px"
            class="logomarca img-fluid"
          />
        </div> -->
        <div class="col-lg-6 col-sm-6 text-center">
          <h4 class="mt-2">Pedido #{{ pedido.id }}</h4>
        </div>
        <div class="col-lg-3"></div>
      </div>
      <div class="mt-2">
        <div class="row mt-2">
          <div class="col-sm-6 pr-0">
            <label>{{ SITE.labelCliente }}</label
            ><br />
            {{ pedido.cliente[SITE.identificacaoCliente] }} -
            {{ pedido.cliente.nome }}
          </div>
          <div class="col-sm-3 pr-0">
            <label>{{ SITE.labelFilial }}</label
            ><br />
            {{ pedido.filial.codigo }} - {{ pedido.filial.descricao }}
          </div>
          <div class="col-sm-3">
            <label>{{ SITE.labelTabela }}</label
            ><br />
            {{ pedido.tabela.codigo }} - {{ pedido.tabela.descricao }}
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row mt-2">
          <div class="col-sm-3">
            <label>Data</label><br />
            {{ pedido.dataAberto }}
          </div>
          <div class="col-sm-3">
            <label>Status</label><br />
            <span *ngIf="apr; else elseBlockAprvCli" style="color: green"
              ><b><u>APROVADO</u></b></span
            >
            <ng-template #elseBlockAprvCli
              ><span style="color: orange"
                ><b><u>AGUARDANDO</u></b></span
              ></ng-template
            >
          </div>
          <div class="col-sm-3">
            <label>Quantidade</label><br />
            {{ pedido.quantidade }}
          </div>
          <div class="col-sm-3">
            <label>Tipo</label><br />
            {{ pedido.tipo.tipo }} - {{ pedido.tipo.descricao }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-5"></div>
          <div class="col-sm-7"></div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="mt-2" id="tablePedidoAberto"></div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-6"></div>
          <div class="col-sm-6 pl-0">
            <div class="row mb-1 pl-0">
              <div class="col-8 text-right pl-0">Subtotal:</div>
              <div class="col-4 pl-0">
                {{ pedido.subtotal | currency : "BRL" }}
              </div>
            </div>
            <div
              *ngIf="pedido.impostos"
              class="row mb-1 pl-0"
              style="color: red"
            >
              <div class="col-8 text-right">+ Impostos:</div>
              <div class="col-4">
                <span>{{ pedido.impostos | currency : "BRL" }}</span>
              </div>
            </div>
            <div class="row mb-1 pl-0">
              <div class="col-8 text-right pl-0">Valor total:</div>
              <div class="col-4 pl-0" style="color: green; font-weight: bold">
                {{ pedido.total | currency : "BRL" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!apr" class="mt-3 mb-4" align="center">
        <button
          (click)="aprova()"
          class="btn btn-success btn-lg"
          style="font-size: 1.2rem !important"
        >
          <i class="icofont-check-circled"></i> Aprovar Pedido
        </button>
      </div>
      <div
        *ngIf="apr"
        class="mt-3 mb-4"
        align="center"
        class="alert alert-success"
        role="alert"
      >
        Pedido aprovado com sucesso!
      </div>
    </div>
  </div>
</div>
